module.exports = __webpack_public_path__ + "static/media/VattenfallHall-Heavy.7205c056.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VattenfallHall-Heavy.woff
// module id = 137
// module chunks = 0